import { useNavigate, useLocation } from 'react-router-dom';

import LogoWhite from '@/assets/ic_gdt-white.svg';
import ROUTES from '@/router/routes';
import { PropsWithClassName } from '@/types';
import { cn } from '@/utils';

const MenuLogo = ({ className }: PropsWithClassName) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleClick = () => {
    if (location.pathname === '/armado/futbol-11') {
      return;
    }

    navigate(ROUTES.summary, { replace: true });
  };

  return (
    <img
      alt="Logo Gran DT"
      className={cn('max-w-full h-auto w-6 mx-auto', className)}
      src={LogoWhite}
      style={{ cursor: 'pointer' }}
      onClick={handleClick}
    />
  );
};

export default MenuLogo;
